import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Part = makeShortcode("Part");
const Ex = makeShortcode("Ex");
const Tr = makeShortcode("Tr");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`誰も寝てはならぬ`}</h1>
    <h4>{`Nessun dorma`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`"Nessun dorma" Roberto Alagna HD720`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/RHyYTYnXP0o?start=30" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Luciano Pavarotti sings "Nessun dorma" from Turandot (The Three Tenors in Concert 1994)`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/cWc7vYjgnTs" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <Part mdxType="Part">Il Principe (王子)</Part>
    <p>
      <Ex m="誰も〜ない" mdxType="Ex">Nessun</Ex> <Ex m="眠る、寝る（命令法）" o="dormire" mdxType="Ex">dorma</Ex>! Nessun dorma!
    </p>
    <Tr mdxType="Tr">誰も寝てはならぬ、か！</Tr>
    <p>
      <Ex m="あなた" mdxType="Ex">Tu</Ex> <Ex m="〜もまた" mdxType="Ex">pure</Ex>, <Ex m="おお〜よ（間投詞）" mdxType="Ex">o</Ex> <Ex m="姫" mdxType="Ex">Principessa</Ex>, <Ex m="in + la (〜の中に)" mdxType="Ex">nella</Ex> <Ex m="あなたの" o="tuo" mdxType="Ex">tua</Ex> <Ex m="冷たい" o="freddo" mdxType="Ex">fredda</Ex> <Ex m="部屋" mdxType="Ex">stanza</Ex>
    </p>
    <Tr mdxType="Tr">あなたもまた、おお、姫よ、あなたの冷たい部屋で</Tr>
    <p>
      <Ex m="見る" o="guardare" mdxType="Ex">guardi</Ex> <Ex m="星（複数）" o="stella" mdxType="Ex">le stelle</Ex> <Ex m="関係代名詞（英語のthat" mdxType="Ex">che</Ex> <Ex m="（di 〜で）震える" o="tremare" mdxType="Ex">tremano</Ex> d'<Ex m="愛" mdxType="Ex">amore</Ex> e di <Ex m="希望" mdxType="Ex">speranza</Ex>!
    </p>
    <Tr mdxType="Tr">愛と希望にまたたく星を見ているのだろう！</Tr>
    <p>
      <Ex m="しかし" mdxType="Ex">Ma</Ex> il <Ex m="私の" mdxType="Ex">mio</Ex> <Ex m="秘密" mdxType="Ex">mistero</Ex> <Ex m="chiudere「閉じ込める、しまう」の受動態" o="chiudere" mdxType="Ex">è chiuso</Ex> in <Ex m="私" mdxType="Ex">me</Ex>,
    </p>
    <Tr mdxType="Tr">だが、私の秘密は私の中にある</Tr>
    <p>
il <Ex m="名前" mdxType="Ex">nome</Ex> <Ex m="私の" mdxType="Ex">mio</Ex> <Ex m="誰も〜ない" o="nessuno" mdxType="Ex">nessun</Ex> <Ex m="知る（未来）" o="sapere" mdxType="Ex">saprà</Ex>!
    </p>
    <Tr mdxType="Tr">誰も私の名前を知ることはないだろう</Tr>
    <p>
No, no, <Ex m="su + la （〜の上に）" mdxType="Ex">sulla</Ex> <Ex m="あなたの" o="tuo" mdxType="Ex">tua</Ex> <Ex m="口" mdxType="Ex">bocca</Ex> <Ex m="それを" mdxType="Ex">lo</Ex> <Ex m="言う（未来）" o="dire" mdxType="Ex">dirò</Ex>,
    </p>
    <Tr mdxType="Tr">いや、いや、あなたの唇の上にそれを告げよう</Tr>
    <p>
      <Ex m="〜の時に" mdxType="Ex">quando</Ex> la <Ex m="光" mdxType="Ex">luce</Ex> <Ex m="輝く（未来）" o="splendere" mdxType="Ex">splenderà</Ex>!
    </p>
    <Tr mdxType="Tr">朝の光が輝くときに！</Tr>
    <p>
      <Ex m="そして（eが母音の前で発音しやすいように変化したもの）" mdxType="Ex">Ed</Ex> il mio <Ex m="キス、口づけ" mdxType="Ex">bacio</Ex> <Ex m="解く（未来）" o="sciogliere" mdxType="Ex">scioglierà</Ex> il <Ex m="沈黙" mdxType="Ex">silenzio</Ex> <Ex m="関係代名詞（英語のthat）（このcheはil silenzioに係る。夜明けまで沈黙していれば姫は自分のものになる、その沈黙をこの口づけによって解くということ）" mdxType="Ex">che</Ex> <Ex m="あなたを" mdxType="Ex">ti</Ex> <Ex m="〜にする" o="fare" mdxType="Ex">fa</Ex> <Ex m="私のもの" o="mio" mdxType="Ex">mia</Ex>!
    </p>
    <Tr mdxType="Tr">そして、私の口づけが、あなたを私のものにする沈黙を解くのだ！</Tr>
    <Part mdxType="Part">Coro Donne (女声の合唱)</Part>
    <p>
Il nome <Ex m="彼の" mdxType="Ex">suo</Ex> nessun saprà...
    </p>
    <Tr mdxType="Tr">誰も彼の名前を知ることはないだろう</Tr>
    <p>
E <Ex m="私たちは" mdxType="Ex">noi</Ex> <Ex m="〜しなければならない（未来 dovremo）" o="dovere" mdxType="Ex">dovrem</Ex>, <Ex m="ああひどい、なんとまた（間投詞）" mdxType="Ex">ahimè</Ex>, <Ex m="死ぬ" o="morire" mdxType="Ex">morir</Ex>, morir!
    </p>
    <Tr mdxType="Tr">そしたら私たちは、ああ、死ななければならない！</Tr>
    <Part mdxType="Part">Il Principe (王子)</Part>
    <p>
      <Ex m="消え去る（命令法）" o="dileguare" mdxType="Ex">Dilegua</Ex>, o <Ex m="夜" mdxType="Ex">notte</Ex>! <Ex m="沈む（命令法）" o="tramontare" mdxType="Ex">tramontate</Ex>, <Ex m="星（複数）" o="stella" mdxType="Ex">stelle</Ex>! Tramontate, stelle!
    </p>
    <Tr mdxType="Tr">おお、夜よ、消え去れ！ 星よ、没せよ！</Tr>
    <p>
      <Ex m="a + l'" mdxType="Ex">All'</Ex><Ex m="夜明け" mdxType="Ex">alba</Ex> <Ex m="勝つ（未来）" o="vincere" mdxType="Ex">vincerò</Ex>! Vincerò! Vincerò!
    </p>
    <Tr mdxType="Tr">夜明けになれば、私の勝ちだ！ 私の勝ちだ！</Tr>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/3523edecef616a5c367022903e1ea993/8698d/turandot-nessun-dorma.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "141.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAABcSAAAXEgFnn9JSAAAC4klEQVRIx63W504rQQwF4Lz/a0UCAUKi995C6L3DXH1GZ5XwD11WMrPrsT0+x/aEXvvP5/39vZOvr6/W8+fj46Pk9va2PT8/1+bb21tJDCPson99fW2np6ft+Pi4nZ+fl673+fnZrq6u2v7+fpuYmGgrKyttfX297e7utqOjo3LY2tpqq6urtfomAuzs7LS1tbXysT4+Pn5n6GHAwXp9fd1ubm4q44eHh3ZxcVH64XBY+mRvj/7y8rL0su8JJsvBYNCmp6fb3t5ebcr67u6uHO7v70tHOBP7+WbncBR0Gf7VUxniInDJ9vZ2cXpwcFB8ecfhyclJIWFLR3yzo6sMBdzc3GyHh4cFgdH8/HxnjD96wXCoUOytOVABJTEG2UpBcKJ9np6eihtF8p2Wok9rsffY6yBLVzFkIKsQr79kJgsIZGJNpnz4hoIOcjgDBQzB8ErP0WpPv3F2iGB82G1sbNQqy7Eqj76DTZwKIniZlMD76dNBXlpaanNzcwXXSYoiK2JPha0EDaZiamqqsk62i4uL7eXl5TsgjsAMX5wUQkHSxPbovaMBdFzKno9DapaTMiipXDrfhDiV3ph5Z8/GdI3C5t9B1mv9fr9IBgsE2YAsE3BQAroqyzIzDoksU8wKKBMBGODQO+JlGohnZ2c1RXQyZmsP7Nw+BVlADpOTkzURDBk4WRCncvJtJficmZlpCwsLVUDXHoRo6oW/3z7uPhlC51DfHYdIdio4DKx0ipBx887JCh57CKz4M0XdfQgOyKAyQAGic7Haz/0HlgJpE/AVUDBTVJOS21p1BRy9TRRodGa9pyf55CKWqYO6ouBASwhAZmdna0W64H5jZKAQgucWRwHRQlY0jc1yeMu8xjg85hfv5zPa5JWh05eXl4uT3L44Ak2z60s2oSX9amXvtvHetU0aFycpzM8qhsv0oYMEcKFk7utyGL2x8x9AripQSP4RyI999BE+Y5D/6pfPvyL/ANfyS0G9/X9sAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/3523edecef616a5c367022903e1ea993/5a190/turandot-nessun-dorma.png",
            "srcSet": ["/static/3523edecef616a5c367022903e1ea993/772e8/turandot-nessun-dorma.png 200w", "/static/3523edecef616a5c367022903e1ea993/e17e5/turandot-nessun-dorma.png 400w", "/static/3523edecef616a5c367022903e1ea993/5a190/turandot-nessun-dorma.png 800w", "/static/3523edecef616a5c367022903e1ea993/c1b63/turandot-nessun-dorma.png 1200w", "/static/3523edecef616a5c367022903e1ea993/8698d/turandot-nessun-dorma.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      